const actionHash = '#rr-open-product-form';
let opening = false;
async function openProductForm() {
  if (location.hash !== actionHash || opening) return;
  opening = true;
  try {
    const root = document.querySelector('.shopify-section--main-product');
    const inquiry = root?.querySelector('rr-product-inquiry');
    const sizing = root?.querySelector('product-sizing-modal[data-presentation="inline"]');
    const target = inquiry || sizing;
    if (target) await customElements.whenDefined(target.localName);
    await document.fonts?.ready;
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    if (location.hash !== actionHash || !root?.isConnected) return;
    history.replaceState(history.state, '', location.pathname + location.search);
    if (inquiry?.opener) inquiry.open(inquiry.opener);
    else if (sizing?.inlineButton) sizing.open(sizing.inlineButton, 'add');
    else root.querySelector('product-form')?.scrollIntoView({block: 'center', behavior: 'smooth'});
  } finally { opening = false; }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openProductForm, {once: true});
else openProductForm();
window.addEventListener('hashchange', openProductForm);
